import { useEffect, useCallback, useContext, useState } from 'react';
import { RemotionPlayerContext } from '../context/RemotionPlayerContext';

export enum PlayRateValue {
  HALF = 0.5,
  NORMAL = 1,
  ONE_POINT_FIVE = 1.5,
  DOUBLE = 2
}

export const useRemotionPlayerRate = () => {
  const { playerRef } = useContext(RemotionPlayerContext);

  // !! TODO hitesh store this in store
  const [rate, _setRate] = useState<PlayRateValue>(PlayRateValue.NORMAL);

  useEffect(() => {
    if (playerRef) {
      const handleRateChange = ({ detail: { playbackRate } }: { detail: { playbackRate: PlayRateValue } }) => {
        _setRate(playbackRate);
      };
      playerRef.addEventListener('ratechange', handleRateChange);
      return () => {
        playerRef.removeEventListener('ratechange', handleRateChange);
      };
    }
  }, [playerRef]);

  const setRate = useCallback(
    (rate: number) => {
      playerRef?.dispatchRateChange(rate);
    },
    [playerRef]
  );

  return { rate, setRate };
};
